import { BadImplementationException, MUSTNeverHappenException } from '@nu-art/ts-common';
export const Operator_Func_If = '?';
export const Operator_AND = '&&';
export const Operator_OR = '||';
export const Operator_NOT = '!';
export const Operator_POWER = '^';
export const Operator_MOD = '%';
export const Operator_DIV = '/';
export const Operator_MULTIPLICATION = '*';
export const Operator_SUBTRACT = '-';
export const Operator_ADDITION = '+';
export const Operator_GREATER_THAN = '>';
export const Operator_LESSER_THAN = '<';
export const Operator_IN_RANGE = '∈';
export const Operator_CONTAINS = 'in';
export const Operator_EQUAL = '===';
export const Operator_SUM = 'Σ';
export const Operator_AVERAGE = 'x̄';
export const Operator_CONDITION_LIST = '?[]';
export const validateType = (value, type, expectedType) => {
    if (typeof value !== expectedType)
        throw new BadImplementationException(`The ${type} hand param is not a ${expectedType}!\n found type: ${typeof value} - "${value}"`);
};
export const ExpressionCore_FunctionalActions = {
    [Operator_Func_If]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) ? _expressionModule.params.eval(params[1]) : _expressionModule.params.eval(params[2]);
    },
    [Operator_CONDITION_LIST]: (_expressionModule, ...params) => {
        for (let i = 0; i < params[0].length; i++) {
            if (_expressionModule.params.eval(params[0][i]))
                return _expressionModule.params.eval(params[1][i]);
        }
    }
};
export const ExpressionCore_FunctionalPrettyPrinting = {
    [Operator_Func_If]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_Func_If} ${params[1]} : ${params[2]})`,
    [Operator_CONDITION_LIST]: (_expressionModule, indent, ...params) => `(${params[0].map((result, index) => `(${result} -> ${params[1][index]})`)})`
    // [Operator_GetPatientVar]: (indent: string, ...params: Params<Op_GetPatientVar>) => `(PV{${params[0]}})`
};
export const ExpressionCore_FunctionalValidation = {
    [Operator_Func_If]: (_expressionModule, ...params) => {
        if (typeof params[0] !== 'boolean')
            throw new BadImplementationException('condition function must return boolean');
    },
    [Operator_CONDITION_LIST]: (_expressionModule, ...params) => {
        params[0].map(item => validateType(item, 'left', 'boolean'));
        if (params[0].length !== params[1].length)
            throw new BadImplementationException('Both lists must be in the same length');
    }
    // [Operator_GetPatientVar]: (...params: Params<Op_GetPatientVar>) => {
    // 	validateType(params[0], 'left', 'string');
    // }
};
export const FunctionalOperators = [Operator_Func_If];
export const ExpressionCore_BooleanActions = {
    [Operator_EQUAL]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) === _expressionModule.params.eval(params[1]);
    },
    [Operator_OR]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]).reduce((toReturn, value) => toReturn || value, params[0][0]);
    },
    [Operator_AND]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]).reduce((toReturn, value) => toReturn && value, params[0][0]);
    },
    [Operator_IN_RANGE]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) > _expressionModule.params.eval(params[1])[0] && _expressionModule.params.eval(params[0]) < _expressionModule.params.eval(params[1])[1];
    },
    [Operator_NOT]: (_expressionModule, ...params) => {
        return !_expressionModule.params.eval(params[0]);
    },
    [Operator_GREATER_THAN]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) > _expressionModule.params.eval(params[1]);
    },
    [Operator_LESSER_THAN]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) < _expressionModule.params.eval(params[1]);
    },
    [Operator_CONTAINS]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]).includes(_expressionModule.params.eval(params[1]));
    }
};
export const ExpressionCore_BooleanPrettyPrinting = {
    [Operator_OR]: (_expressionModule, indent, ...params) => `(${params[0].join(` ${Operator_OR} `)})`,
    [Operator_AND]: (_expressionModule, indent, ...params) => `(${params[0].join(` ${Operator_AND} `)})`,
    [Operator_IN_RANGE]: (_expressionModule, indent, ...params) => `(${params[1][0]} ${Operator_LESSER_THAN} ${params[0]} ${Operator_LESSER_THAN} ${params[1][1]})`,
    [Operator_NOT]: (_expressionModule, indent, ...params) => `(${Operator_NOT}${params[0]})`,
    [Operator_GREATER_THAN]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_GREATER_THAN} ${params[1]})`,
    [Operator_LESSER_THAN]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_LESSER_THAN} ${params[1]})`,
    [Operator_CONTAINS]: (_expressionModule, indent, ...params) => `(${JSON.stringify(params[1])}.include(${params[0]}))`,
    [Operator_EQUAL]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_EQUAL} ${params[1]})`,
};
export const BooleanOperators = [Operator_EQUAL,
    Operator_OR,
    Operator_NOT,
    Operator_AND,
    Operator_IN_RANGE,
    Operator_CONTAINS,
    Operator_LESSER_THAN,
    Operator_GREATER_THAN];
export const ExpressionCore_BooleanValidation = {
    [Operator_IN_RANGE]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        params[1].map(item => validateType(item, 'right', 'number'));
        if (params[1][0] > params[1][1])
            throw new MUSTNeverHappenException(`Right side of the range can't bigger than the left side got - [${params[1][0]}], ${params[1][1]}`);
    },
    [Operator_NOT]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'boolean');
    },
    [Operator_GREATER_THAN]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_LESSER_THAN]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_CONTAINS]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'string');
        params[1].map(item => validateType(item, 'right', 'string'));
    },
    [Operator_EQUAL]: (_expressionModule, ...params) => {
    },
    [Operator_OR]: (_expressionModule, ...params) => {
        params.map(item => validateType(item, 'right', 'boolean'));
    },
    [Operator_AND]: (_expressionModule, ...params) => {
        params.map(item => validateType(item, 'right', 'boolean'));
    },
};
export const ExpressionsCore_BasicMath = {
    [Operator_ADDITION]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) + _expressionModule.params.eval(params[1]);
    },
    [Operator_SUBTRACT]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) - _expressionModule.params.eval(params[1]);
    },
    [Operator_MOD]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) % _expressionModule.params.eval(params[1]);
    },
    [Operator_POWER]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) ** _expressionModule.params.eval(params[1]);
    },
    [Operator_DIV]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) / _expressionModule.params.eval(params[1]);
    },
    [Operator_MULTIPLICATION]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]) * _expressionModule.params.eval(params[1]);
    },
    [Operator_SUM]: (_expressionModule, ...params) => {
        return _expressionModule.params.eval(params[0]).reduce((sum, currItem) => sum += currItem, 0);
    },
    [Operator_AVERAGE]: (_expressionModule, ...params) => {
        return ExpressionsCore_BasicMath[Operator_SUM](_expressionModule, _expressionModule.params.eval(params[0])) / _expressionModule.params.eval(params[0]).length;
    }
};
export const ExpressionCore_BasicMathPrettyPrinting = {
    [Operator_ADDITION]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_ADDITION} ${params[1]})`,
    [Operator_SUBTRACT]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_SUBTRACT} ${params[1]})`,
    [Operator_MOD]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_MOD} ${params[1]})`,
    [Operator_POWER]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_POWER} ${params[1]})`,
    [Operator_DIV]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_DIV} ${params[1]})`,
    [Operator_MULTIPLICATION]: (_expressionModule, indent, ...params) => `(${params[0]} ${Operator_MULTIPLICATION} ${params[1]})`,
    [Operator_SUM]: (_expressionModule, indent, ...params) => `(${params[0].join(` ${Operator_ADDITION} `)})`,
    [Operator_AVERAGE]: (_expressionModule, indent, ...params) => `((${params[0].join(` ${Operator_ADDITION} `)}) ${Operator_DIV} ${params[0].length})`
};
export const ExpressionCore_BasicMathValidation = {
    [Operator_ADDITION]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_SUBTRACT]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_MOD]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_POWER]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_DIV]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_MULTIPLICATION]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'number');
        validateType(params[1], 'right', 'number');
    },
    [Operator_SUM]: (_expressionModule, ...params) => {
        params[0].map(param => validateType(param, 'left', 'number'));
    },
    [Operator_AVERAGE]: (_expressionModule, ...params) => {
        params[0].map(param => validateType(param, 'left', 'number'));
    }
};
export const BasicMatchOperators = [Operator_POWER,
    Operator_ADDITION,
    Operator_MOD,
    Operator_SUBTRACT,
    Operator_MULTIPLICATION,
    Operator_DIV,
    Operator_SUM,
    Operator_AVERAGE];
export const AllOperands = [...BasicMatchOperators, ...BooleanOperators, ...FunctionalOperators];
export const ExpressionCore_BasicMathOptions = {
    Operators: BasicMatchOperators,
    OperatorPrinter: ExpressionCore_BasicMathPrettyPrinting,
    OperatorProcessors: ExpressionsCore_BasicMath,
    OperatorValidation: ExpressionCore_BasicMathValidation
};
export const ExpressionCore_BooleanOptions = {
    Operators: BooleanOperators,
    OperatorPrinter: ExpressionCore_BooleanPrettyPrinting,
    OperatorProcessors: ExpressionCore_BooleanActions,
    OperatorValidation: ExpressionCore_BooleanValidation
};
export const ExpressionCore_FunctionalOptions = {
    Operators: FunctionalOperators,
    OperatorPrinter: ExpressionCore_FunctionalPrettyPrinting,
    OperatorProcessors: ExpressionCore_FunctionalActions,
    OperatorValidation: ExpressionCore_FunctionalValidation
};
export const defaultExpressionOptions = [
    ExpressionCore_BasicMathOptions,
    ExpressionCore_BooleanOptions,
    ExpressionCore_FunctionalOptions
];
//# sourceMappingURL=consts.js.map